import { addDays, format } from "date-fns";

import { URL_TRIVIA_IMAGE } from "../../src/lib/constants/urls/urlTrivia";
import type { TriviaLeaderboard } from "../../src/lib/types/schema/home/triviaLeaderboardSchema";
import type {
  TriviaGame,
  TriviaUserAnswer,
} from "../../src/lib/types/schema/home/triviaSchema";
import { MOCK_DATA_GET_AVATARS } from "./mockDataGetAvatars";
import { MOCK_DATA_GET_ME } from "./mockDataGetMe";
import { mockRecommendationDeeplink } from "./mockRecommendationDeeplink";

export const mockDataTrivia = {
  color: "rgb(56, 4, 103)",
  imgSrc: {
    large: URL_TRIVIA_IMAGE,
  },
  questions: [
    {
      id: 4862,
      text: "On this day in 1506, Pope Julius II laid the foundation stone for the current building of which basilica in Vatican City?",
      category: "History",
      explanation: null,
      user_answer: {
        answer_id: 25219,
        seconds_elapsed: 0,
      },
      answers: [
        {
          id: 25222,
          text: "St. John Lateran Basilica",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25219,
          text: "St. Peter's Basilica",
          correct: true,
          percentage: 0.5,
        },
        {
          id: 25220,
          text: "St. Mary Major Basilica",
          correct: false,
          percentage: 0,
        },
        {
          id: 25221,
          text: "St. Paul Outside the Walls Basilica",
          correct: false,
          percentage: 0,
        },
      ],
    },
    {
      id: 4863,
      text: "Which saint is often depicted with a lamb?",
      category: "Saints",
      explanation: null,
      user_answer: {
        answer_id: 25225,
        seconds_elapsed: 0,
      },
      answers: [
        {
          id: 25226,
          text: "St. Brigid",
          correct: false,
          percentage: 0,
        },
        {
          id: 25223,
          text: "St. Agnes",
          correct: true,
          percentage: 0,
        },
        {
          id: 25224,
          text: "St. Luke",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25225,
          text: "St. Roch",
          correct: false,
          percentage: 0.5,
        },
      ],
    },
    {
      id: 4864,
      text: 'Which book of the Bible is NOT classified as a "Biblical Novella"?',
      category: "Scripture",
      explanation: null,
      user_answer: {
        answer_id: 25229,
        seconds_elapsed: 0,
      },
      answers: [
        {
          id: 25227,
          text: "Sirach",
          correct: true,
          percentage: 0.5,
        },
        {
          id: 25228,
          text: "Tobit",
          correct: false,
          percentage: 0,
        },
        {
          id: 25229,
          text: "Judith",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25230,
          text: "Esther",
          correct: false,
          percentage: 0,
        },
      ],
    },
    {
      id: 4865,
      text: "Which plant gets its name because it is often in full bloom around June 24th, the birthday of its namesake?",
      category: "Pop Culture",
      explanation: null,
      user_answer: {
        answer_id: 25234,
        seconds_elapsed: 1,
      },
      answers: [
        {
          id: 25234,
          text: "Rose of Sharon",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25233,
          text: "Joseph's Coat",
          correct: false,
          percentage: 0,
        },
        {
          id: 25231,
          text: "St. John's Wort",
          correct: true,
          percentage: 0,
        },
        {
          id: 25232,
          text: "St. Bernard's Lily",
          correct: false,
          percentage: 0.5,
        },
      ],
    },
    {
      id: 4866,
      text: "Which virtue is a commitment to truthfulness and accuracy in speech and action?",
      category: "Spirituality",
      explanation: null,
      user_answer: {
        answer_id: 25235,
        seconds_elapsed: 1,
      },
      answers: [
        {
          id: 25238,
          text: "Taciturnity",
          correct: false,
          percentage: 0,
        },
        {
          id: 25237,
          text: "Diligence",
          correct: false,
          percentage: 0,
        },
        {
          id: 25236,
          text: "Solicitude",
          correct: false,
          percentage: 0,
        },
        {
          id: 25235,
          text: "Veracity",
          correct: true,
          percentage: 1,
        },
      ],
    },
  ],
  summary: {
    total_seconds_elapsed: 12030,
    streak: 12,
    longest_streak: 30,
  },
} as const;

export const mockDataTriviaFinished: TriviaGame = {
  questions: [
    {
      id: 4862,
      text: "On this day in 1506, Pope Julius II laid the foundation stone for the current building of which basilica in Vatican City?",
      category: "History",
      explanation: null,
      user_answer: {
        answer_id: 25219,
        seconds_elapsed: 0,
      },
      answers: [
        {
          id: 25222,
          text: "St. John Lateran Basilica",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25219,
          text: "St. Peter's Basilica",
          correct: true,
          percentage: 0.5,
        },
        {
          id: 25220,
          text: "St. Mary Major Basilica",
          correct: false,
          percentage: 0,
        },
        {
          id: 25221,
          text: "St. Paul Outside the Walls Basilica",
          correct: false,
          percentage: 0,
        },
      ],
    },
    {
      id: 4863,
      text: "Which saint is often depicted with a lamb?",
      category: "Saints",
      explanation: null,
      user_answer: {
        answer_id: 25225,
        seconds_elapsed: 0,
      },
      answers: [
        {
          id: 25226,
          text: "St. Brigid",
          correct: false,
          percentage: 0,
        },
        {
          id: 25223,
          text: "St. Agnes",
          correct: true,
          percentage: 0,
        },
        {
          id: 25224,
          text: "St. Luke",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25225,
          text: "St. Roch",
          correct: false,
          percentage: 0.5,
        },
      ],
    },
    {
      id: 4864,
      text: 'Which book of the Bible is NOT classified as a "Biblical Novella"?',
      category: "Scripture",
      explanation: null,
      user_answer: {
        answer_id: 25229,
        seconds_elapsed: 0,
      },
      answers: [
        {
          id: 25227,
          text: "Sirach",
          correct: true,
          percentage: 0.5,
        },
        {
          id: 25228,
          text: "Tobit",
          correct: false,
          percentage: 0,
        },
        {
          id: 25229,
          text: "Judith",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25230,
          text: "Esther",
          correct: false,
          percentage: 0,
        },
      ],
    },
    {
      id: 4865,
      text: "Which plant gets its name because it is often in full bloom around June 24th, the birthday of its namesake?",
      category: "Pop Culture",
      explanation: null,
      user_answer: {
        answer_id: 25234,
        seconds_elapsed: 1,
      },
      answers: [
        {
          id: 25234,
          text: "Rose of Sharon",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25233,
          text: "Joseph's Coat",
          correct: false,
          percentage: 0,
        },
        {
          id: 25231,
          text: "St. John's Wort",
          correct: true,
          percentage: 0,
        },
        {
          id: 25232,
          text: "St. Bernard's Lily",
          correct: false,
          percentage: 0.5,
        },
      ],
    },
    {
      id: 4866,
      text: "Which virtue is a commitment to truthfulness and accuracy in speech and action?",
      category: "Spirituality",
      explanation: null,
      user_answer: {
        answer_id: 25235,
        seconds_elapsed: 1,
      },
      answers: [
        {
          id: 25238,
          text: "Taciturnity",
          correct: false,
          percentage: 0,
        },
        {
          id: 25237,
          text: "Diligence",
          correct: false,
          percentage: 0,
        },
        {
          id: 25236,
          text: "Solicitude",
          correct: false,
          percentage: 0,
        },
        {
          id: 25235,
          text: "Veracity",
          correct: true,
          percentage: 1,
        },
      ],
    },
  ],
  summary: {
    total_seconds_elapsed: 12030,
    streak: 12,
    longest_streak: 30,
  },
  is_in_routine: false,
  recommendations: [mockRecommendationDeeplink],
  state: "FINISHED",
  id: 3,
  player_count: 5012,
  available_at: format(new Date(), "yyyy-MM-dd'T'hh:mm:ss'Z'"),
  ends_at: format(addDays(new Date(), 1), "yyyy-MM-dd'T'hh:mm:ss'Z'"),
};

export const mockDataTriviaFinishedWithoutRecommendations: TriviaGame = {
  questions: [
    {
      id: 4862,
      text: "On this day in 1506, Pope Julius II laid the foundation stone for the current building of which basilica in Vatican City?",
      category: "History",
      explanation: null,
      user_answer: {
        answer_id: 25219,
        seconds_elapsed: 0,
      },
      answers: [
        {
          id: 25222,
          text: "St. John Lateran Basilica",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25219,
          text: "St. Peter's Basilica",
          correct: true,
          percentage: 0.5,
        },
        {
          id: 25220,
          text: "St. Mary Major Basilica",
          correct: false,
          percentage: 0,
        },
        {
          id: 25221,
          text: "St. Paul Outside the Walls Basilica",
          correct: false,
          percentage: 0,
        },
      ],
    },
    {
      id: 4863,
      text: "Which saint is often depicted with a lamb?",
      category: "Saints",
      explanation: null,
      user_answer: {
        answer_id: 25225,
        seconds_elapsed: 0,
      },
      answers: [
        {
          id: 25226,
          text: "St. Brigid",
          correct: false,
          percentage: 0,
        },
        {
          id: 25223,
          text: "St. Agnes",
          correct: true,
          percentage: 0,
        },
        {
          id: 25224,
          text: "St. Luke",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25225,
          text: "St. Roch",
          correct: false,
          percentage: 0.5,
        },
      ],
    },
    {
      id: 4864,
      text: 'Which book of the Bible is NOT classified as a "Biblical Novella"?',
      category: "Scripture",
      explanation: null,
      user_answer: {
        answer_id: 25229,
        seconds_elapsed: 0,
      },
      answers: [
        {
          id: 25227,
          text: "Sirach",
          correct: true,
          percentage: 0.5,
        },
        {
          id: 25228,
          text: "Tobit",
          correct: false,
          percentage: 0,
        },
        {
          id: 25229,
          text: "Judith",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25230,
          text: "Esther",
          correct: false,
          percentage: 0,
        },
      ],
    },
    {
      id: 4865,
      text: "Which plant gets its name because it is often in full bloom around June 24th, the birthday of its namesake?",
      category: "Pop Culture",
      explanation: null,
      user_answer: {
        answer_id: 25234,
        seconds_elapsed: 1,
      },
      answers: [
        {
          id: 25234,
          text: "Rose of Sharon",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25233,
          text: "Joseph's Coat",
          correct: false,
          percentage: 0,
        },
        {
          id: 25231,
          text: "St. John's Wort",
          correct: true,
          percentage: 0,
        },
        {
          id: 25232,
          text: "St. Bernard's Lily",
          correct: false,
          percentage: 0.5,
        },
      ],
    },
    {
      id: 4866,
      text: "Which virtue is a commitment to truthfulness and accuracy in speech and action?",
      category: "Spirituality",
      explanation: null,
      user_answer: {
        answer_id: 25235,
        seconds_elapsed: 1,
      },
      answers: [
        {
          id: 25238,
          text: "Taciturnity",
          correct: false,
          percentage: 0,
        },
        {
          id: 25237,
          text: "Diligence",
          correct: false,
          percentage: 0,
        },
        {
          id: 25236,
          text: "Solicitude",
          correct: false,
          percentage: 0,
        },
        {
          id: 25235,
          text: "Veracity",
          correct: true,
          percentage: 1,
        },
      ],
    },
  ],
  summary: {
    total_seconds_elapsed: 12030,
    streak: 12,
    longest_streak: 30,
  },
  recommendations: [],
  state: "FINISHED",
  id: 3,
  player_count: 5012,
  available_at: format(new Date(), "yyyy-MM-dd'T'hh:mm:ss'Z'"),
  ends_at: format(addDays(new Date(), 1), "yyyy-MM-dd'T'hh:mm:ss'Z'"),
};

export const mockDataTriviaUnstarted: TriviaGame = {
  questions: [
    {
      id: 4862,
      text: "On this day in 1506, Pope Julius II laid the foundation stone for the current building of which basilica in Vatican City?",
      category: "History",
      explanation: null,
      user_answer: null,
      answers: [
        {
          id: 25222,
          text: "St. John Lateran Basilica",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25219,
          text: "St. Peter's Basilica",
          correct: true,
          percentage: 0.5,
        },
        {
          id: 25220,
          text: "St. Mary Major Basilica",
          correct: false,
          percentage: 0,
        },
        {
          id: 25221,
          text: "St. Paul Outside the Walls Basilica",
          correct: false,
          percentage: 0,
        },
      ],
    },
    {
      id: 4863,
      text: "Which saint is often depicted with a lamb?",
      category: "Saints",
      explanation: null,
      user_answer: null,
      answers: [
        {
          id: 25226,
          text: "St. Brigid",
          correct: false,
          percentage: 0,
        },
        {
          id: 25223,
          text: "St. Agnes",
          correct: true,
          percentage: 0,
        },
        {
          id: 25224,
          text: "St. Luke",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25225,
          text: "St. Roch",
          correct: false,
          percentage: 0.5,
        },
      ],
    },
    {
      id: 4864,
      text: 'Which book of the Bible is NOT classified as a "Biblical Novella"?',
      category: "Scripture",
      explanation: null,
      user_answer: null,
      answers: [
        {
          id: 25227,
          text: "Sirach",
          correct: true,
          percentage: 0.5,
        },
        {
          id: 25228,
          text: "Tobit",
          correct: false,
          percentage: 0,
        },
        {
          id: 25229,
          text: "Judith",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25230,
          text: "Esther",
          correct: false,
          percentage: 0,
        },
      ],
    },
    {
      id: 4865,
      text: "Which plant gets its name because it is often in full bloom around June 24th, the birthday of its namesake?",
      category: "Pop Culture",
      explanation: null,
      user_answer: null,
      answers: [
        {
          id: 25234,
          text: "Rose of Sharon",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25233,
          text: "Joseph's Coat",
          correct: false,
          percentage: 0,
        },
        {
          id: 25231,
          text: "St. John's Wort",
          correct: true,
          percentage: 0,
        },
        {
          id: 25232,
          text: "St. Bernard's Lily",
          correct: false,
          percentage: 0.5,
        },
      ],
    },
    {
      id: 4866,
      text: "Which virtue is a commitment to truthfulness and accuracy in speech and action?",
      category: "Spirituality",
      explanation: null,
      user_answer: null,
      answers: [
        {
          id: 25238,
          text: "Taciturnity",
          correct: false,
          percentage: 0,
        },
        {
          id: 25237,
          text: "Diligence",
          correct: false,
          percentage: 0,
        },
        {
          id: 25236,
          text: "Solicitude",
          correct: false,
          percentage: 0,
        },
        {
          id: 25235,
          text: "Veracity",
          correct: true,
          percentage: 1,
        },
      ],
    },
  ],
  summary: {
    total_seconds_elapsed: 0,
    streak: 12,
    longest_streak: 30,
  },
  recommendations: [mockRecommendationDeeplink],
  state: "UNSTARTED",
  id: 3,
  player_count: 5012,
  available_at: format(new Date(), "yyyy-MM-dd'T'hh:mm:ss'Z'"),
  ends_at: format(addDays(new Date(), 1), "yyyy-MM-dd'T'hh:mm:ss'Z'"),
};

export const mockDataTriviaStarted: TriviaGame = {
  questions: [
    {
      id: 4862,
      text: "On this day in 1506, Pope Julius II laid the foundation stone for the current building of which basilica in Vatican City?",
      category: "History",
      explanation: null,
      user_answer: {
        answer_id: 25222,
        seconds_elapsed: 0,
      },
      answers: [
        {
          id: 25222,
          text: "St. John Lateran Basilica",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25219,
          text: "St. Peter's Basilica",
          correct: true,
          percentage: 0.5,
        },
        {
          id: 25220,
          text: "St. Mary Major Basilica",
          correct: false,
          percentage: 0,
        },
        {
          id: 25221,
          text: "St. Paul Outside the Walls Basilica",
          correct: false,
          percentage: 0,
        },
      ],
    },
    {
      id: 4863,
      text: "Which saint is often depicted with a lamb?",
      category: "Saints",
      explanation: null,
      user_answer: {
        answer_id: 25225,
        seconds_elapsed: 0,
      },
      answers: [
        {
          id: 25226,
          text: "St. Brigid",
          correct: false,
          percentage: 0,
        },
        {
          id: 25223,
          text: "St. Agnes",
          correct: true,
          percentage: 0,
        },
        {
          id: 25224,
          text: "St. Luke",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25225,
          text: "St. Roch",
          correct: false,
          percentage: 0.5,
        },
      ],
    },
    {
      id: 4864,
      text: 'Which book of the Bible is NOT classified as a "Biblical Novella"?',
      category: "Scripture",
      explanation: null,
      user_answer: null,
      answers: [
        {
          id: 25227,
          text: "Sirach",
          correct: true,
          percentage: 0.5,
        },
        {
          id: 25228,
          text: "Tobit",
          correct: false,
          percentage: 0,
        },
        {
          id: 25229,
          text: "Judith",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25230,
          text: "Esther",
          correct: false,
          percentage: 0,
        },
      ],
    },
    {
      id: 4865,
      text: "Which plant gets its name because it is often in full bloom around June 24th, the birthday of its namesake?",
      category: "Pop Culture",
      explanation: null,
      user_answer: null,
      answers: [
        {
          id: 25234,
          text: "Rose of Sharon",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25233,
          text: "Joseph's Coat",
          correct: false,
          percentage: 0,
        },
        {
          id: 25231,
          text: "St. John's Wort",
          correct: true,
          percentage: 0,
        },
        {
          id: 25232,
          text: "St. Bernard's Lily",
          correct: false,
          percentage: 0.5,
        },
      ],
    },
    {
      id: 4866,
      text: "Which virtue is a commitment to truthfulness and accuracy in speech and action?",
      category: "Spirituality",
      explanation: null,
      user_answer: null,
      answers: [
        {
          id: 25238,
          text: "Taciturnity",
          correct: false,
          percentage: 0,
        },
        {
          id: 25237,
          text: "Diligence",
          correct: false,
          percentage: 0,
        },
        {
          id: 25236,
          text: "Solicitude",
          correct: false,
          percentage: 0,
        },
        {
          id: 25235,
          text: "Veracity",
          correct: true,
          percentage: 1,
        },
      ],
    },
  ],
  summary: {
    total_seconds_elapsed: 43,
    streak: 12,
    longest_streak: 30,
  },
  recommendations: [mockRecommendationDeeplink],
  state: "STARTED",
  id: 3,
  player_count: 5012,
  available_at: format(new Date(), "yyyy-MM-dd'T'hh:mm:ss'Z'"),
  ends_at: format(addDays(new Date(), 1), "yyyy-MM-dd'T'hh:mm:ss'Z'"),
};

export const mockDataTriviaBonus: TriviaGame = {
  questions: [
    {
      id: 4862,
      text: "On this day in 1506, Pope Julius II laid the foundation stone for the current building of which basilica in Vatican City?",
      category: "History",
      explanation: null,
      user_answer: null,
      answers: [
        {
          id: 25222,
          text: "St. John Lateran Basilica",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25219,
          text: "St. Peter's Basilica",
          correct: true,
          percentage: 0.5,
        },
        {
          id: 25220,
          text: "St. Mary Major Basilica",
          correct: false,
          percentage: 0,
        },
        {
          id: 25221,
          text: "St. Paul Outside the Walls Basilica",
          correct: false,
          percentage: 0,
        },
      ],
    },
    {
      id: 4863,
      text: "Which saint is often depicted with a lamb?",
      category: "Saints",
      explanation: null,
      user_answer: null,
      answers: [
        {
          id: 25226,
          text: "St. Brigid",
          correct: false,
          percentage: 0,
        },
        {
          id: 25223,
          text: "St. Agnes",
          correct: true,
          percentage: 0,
        },
        {
          id: 25224,
          text: "St. Luke",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25225,
          text: "St. Roch",
          correct: false,
          percentage: 0.5,
        },
      ],
    },
    {
      id: 4864,
      text: 'Which book of the Bible is NOT classified as a "Biblical Novella"?',
      category: "Scripture",
      explanation: null,
      user_answer: null,
      answers: [
        {
          id: 25227,
          text: "Sirach",
          correct: true,
          percentage: 0.5,
        },
        {
          id: 25228,
          text: "Tobit",
          correct: false,
          percentage: 0,
        },
        {
          id: 25229,
          text: "Judith",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25230,
          text: "Esther",
          correct: false,
          percentage: 0,
        },
      ],
    },
    {
      id: 4865,
      text: "Which plant gets its name because it is often in full bloom around June 24th, the birthday of its namesake?",
      category: "Pop Culture",
      explanation: null,
      user_answer: null,
      answers: [
        {
          id: 25234,
          text: "Rose of Sharon",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25233,
          text: "Joseph's Coat",
          correct: false,
          percentage: 0,
        },
        {
          id: 25231,
          text: "St. John's Wort",
          correct: true,
          percentage: 0,
        },
        {
          id: 25232,
          text: "St. Bernard's Lily",
          correct: false,
          percentage: 0.5,
        },
      ],
    },
    {
      id: 4866,
      text: "Which virtue is a commitment to truthfulness and accuracy in speech and action?",
      category: "Spirituality",
      explanation: null,
      user_answer: null,
      answers: [
        {
          id: 25238,
          text: "Taciturnity",
          correct: false,
          percentage: 0,
        },
        {
          id: 25237,
          text: "Diligence",
          correct: false,
          percentage: 0,
        },
        {
          id: 25236,
          text: "Solicitude",
          correct: false,
          percentage: 0,
        },
        {
          id: 25235,
          text: "Veracity",
          correct: true,
          percentage: 1,
        },
      ],
    },
    {
      id: 4867,
      text: "What is best in life?",
      category: "Ethics",
      user_answer: null,
      explanation:
        "Arnold Schwarzenegger's character Conan the Barbarian asked this question.",
      answers: [
        {
          id: 25242,
          text: "To crush your enemies",
          correct: false,
          percentage: 0.27,
        },
        {
          id: 25241,
          text: "To see them flee before you",
          correct: false,
          percentage: 0.31,
        },
        {
          id: 25240,
          text: "To hear the lamentations of their women",
          correct: false,
          percentage: 0.16,
        },
        {
          id: 25239,
          text: "All of the above",
          correct: true,
          percentage: 0.26,
        },
      ],
    },
  ],
  summary: {
    total_seconds_elapsed: 0,
    streak: 12,
    longest_streak: 30,
  },
  recommendations: [mockRecommendationDeeplink],
  state: "UNSTARTED",
  id: 3,
  player_count: 5012,
  available_at: format(new Date(), "yyyy-MM-dd'T'hh:mm:ss'Z'"),
  ends_at: format(addDays(new Date(), 1), "yyyy-MM-dd'T'hh:mm:ss'Z'"),
};

export const mockDataTriviaBonusFinished: TriviaGame = {
  questions: [
    {
      id: 4862,
      text: "On this day in 1506, Pope Julius II laid the foundation stone for the current building of which basilica in Vatican City?",
      category: "History",
      explanation: null,
      user_answer: {
        answer_id: 25219,
        seconds_elapsed: 3,
      },
      answers: [
        {
          id: 25222,
          text: "St. John Lateran Basilica",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25219,
          text: "St. Peter's Basilica",
          correct: true,
          percentage: 0.5,
        },
        {
          id: 25220,
          text: "St. Mary Major Basilica",
          correct: false,
          percentage: 0,
        },
        {
          id: 25221,
          text: "St. Paul Outside the Walls Basilica",
          correct: false,
          percentage: 0,
        },
      ],
    },
    {
      id: 4863,
      text: "Which saint is often depicted with a lamb?",
      category: "Saints",
      explanation: null,
      user_answer: {
        answer_id: 25223,
        seconds_elapsed: 7,
      },
      answers: [
        {
          id: 25226,
          text: "St. Brigid",
          correct: false,
          percentage: 0,
        },
        {
          id: 25223,
          text: "St. Agnes",
          correct: true,
          percentage: 0,
        },
        {
          id: 25224,
          text: "St. Luke",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25225,
          text: "St. Roch",
          correct: false,
          percentage: 0.5,
        },
      ],
    },
    {
      id: 4864,
      text: 'Which book of the Bible is NOT classified as a "Biblical Novella"?',
      category: "Scripture",
      explanation: null,
      user_answer: {
        answer_id: 25227,
        seconds_elapsed: 4,
      },
      answers: [
        {
          id: 25227,
          text: "Sirach",
          correct: true,
          percentage: 0.5,
        },
        {
          id: 25228,
          text: "Tobit",
          correct: false,
          percentage: 0,
        },
        {
          id: 25229,
          text: "Judith",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25230,
          text: "Esther",
          correct: false,
          percentage: 0,
        },
      ],
    },
    {
      id: 4865,
      text: "Which plant gets its name because it is often in full bloom around June 24th, the birthday of its namesake?",
      category: "Pop Culture",
      explanation: null,
      user_answer: {
        answer_id: 25231,
        seconds_elapsed: 11,
      },
      answers: [
        {
          id: 25234,
          text: "Rose of Sharon",
          correct: false,
          percentage: 0.5,
        },
        {
          id: 25233,
          text: "Joseph's Coat",
          correct: false,
          percentage: 0,
        },
        {
          id: 25231,
          text: "St. John's Wort",
          correct: true,
          percentage: 0,
        },
        {
          id: 25232,
          text: "St. Bernard's Lily",
          correct: false,
          percentage: 0.5,
        },
      ],
    },
    {
      id: 4866,
      text: "Which virtue is a commitment to truthfulness and accuracy in speech and action?",
      category: "Spirituality",
      explanation: null,
      user_answer: {
        answer_id: 25235,
        seconds_elapsed: 3,
      },
      answers: [
        {
          id: 25238,
          text: "Taciturnity",
          correct: false,
          percentage: 0,
        },
        {
          id: 25237,
          text: "Diligence",
          correct: false,
          percentage: 0,
        },
        {
          id: 25236,
          text: "Solicitude",
          correct: false,
          percentage: 0,
        },
        {
          id: 25235,
          text: "Veracity",
          correct: true,
          percentage: 1,
        },
      ],
    },
    {
      id: 4867,
      text: "What is best in life?",
      category: "Ethics",
      explanation:
        "Arnold Schwarzenegger's character Conan the Barbarian asked this question.",
      user_answer: {
        answer_id: 25239,
        seconds_elapsed: 15,
      },
      answers: [
        {
          id: 25242,
          text: "To crush your enemies",
          correct: false,
          percentage: 0.27,
        },
        {
          id: 25241,
          text: "To see them flee before you",
          correct: false,
          percentage: 0.31,
        },
        {
          id: 25240,
          text: "To hear the lamentations of their women",
          correct: false,
          percentage: 0.16,
        },
        {
          id: 25239,
          text: "All of the above",
          correct: true,
          percentage: 0.26,
        },
      ],
    },
  ],
  summary: {
    total_seconds_elapsed: 0,
    streak: 12,
    longest_streak: 30,
  },
  recommendations: [mockRecommendationDeeplink],
  state: "FINISHED",
  id: 3,
  player_count: 5012,
  available_at: format(new Date(), "yyyy-MM-dd'T'hh:mm:ss'Z'"),
  ends_at: format(addDays(new Date(), 1), "yyyy-MM-dd'T'hh:mm:ss'Z'"),
};

export const mockUserAnswer: TriviaUserAnswer = {
  answer_id: 25222,
  seconds_elapsed: 4,
  game_id: 3,
  user_id: MOCK_DATA_GET_ME.id,
  question_id: 4862,
};

export const mockLeaderboardZeroFriends: TriviaLeaderboard = {
  start_date: format(new Date(), "yyyy-MM-dd"),
  end_date: format(new Date(), "yyyy-MM-dd"),
  has_friends: false,
  scores: [
    {
      score: 12,
      user: {
        name: MOCK_DATA_GET_ME.name,
        last_name: MOCK_DATA_GET_ME.last_name,
        id: MOCK_DATA_GET_ME.id,
        username: "me",
        image_url: MOCK_DATA_GET_ME.image_url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: true,
        is_friend: false,
        relationship_state: "self",
      },
    },
  ],
};

export const mockLeaderboardBoringFriends: TriviaLeaderboard = {
  start_date: format(new Date(), "yyyy-MM-dd"),
  end_date: format(new Date(), "yyyy-MM-dd"),
  has_friends: true,
  scores: [
    {
      score: 12,
      user: {
        name: MOCK_DATA_GET_ME.name,
        last_name: MOCK_DATA_GET_ME.last_name,
        id: MOCK_DATA_GET_ME.id,
        username: "me",
        image_url: MOCK_DATA_GET_ME.image_url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: true,
        is_friend: false,
        relationship_state: "self",
      },
    },
  ],
};

export const mockLeaderboardBest: TriviaLeaderboard = {
  start_date: format(new Date(), "yyyy-MM-dd"),
  end_date: format(new Date(), "yyyy-MM-dd"),
  has_friends: true,
  scores: [
    {
      score: 30,
      user: {
        name: MOCK_DATA_GET_ME.name,
        last_name: MOCK_DATA_GET_ME.last_name,
        id: MOCK_DATA_GET_ME.id,
        username: "me",
        image_url: MOCK_DATA_GET_ME.image_url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: true,
        is_friend: false,
        relationship_state: "self",
      },
    },
    {
      score: 25,
      user: {
        name: "John",
        last_name: "Great",
        id: 25,
        username: "jdoe25",
        image_url: MOCK_DATA_GET_AVATARS[2].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
    {
      score: 20,
      user: {
        name: "John",
        last_name: "Good",
        id: 40,
        username: "jdoe40",
        image_url: MOCK_DATA_GET_AVATARS[1].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
    {
      score: 15,
      user: {
        name: "John",
        last_name: "Mediocre",
        id: 35,
        username: "jdoe35",
        image_url: MOCK_DATA_GET_AVATARS[3].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
    {
      score: 10,
      user: {
        name: "John",
        last_name: "Okay",
        id: 30,
        username: "jdoe30",
        image_url: MOCK_DATA_GET_AVATARS[9].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
    {
      score: 5,
      user: {
        name: "John",
        last_name: "Bad",
        id: 45,
        username: "jdoe45",
        image_url: MOCK_DATA_GET_AVATARS[5].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
    {
      score: 1,
      user: {
        name: "John",
        last_name: "Last",
        id: 50,
        username: "jdoe50",
        image_url: MOCK_DATA_GET_AVATARS[7].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
  ],
};

export const mockLeaderboardWorst: TriviaLeaderboard = {
  start_date: format(new Date(), "yyyy-MM-dd"),
  end_date: format(new Date(), "yyyy-MM-dd"),
  has_friends: true,
  scores: [
    {
      score: 25,
      user: {
        name: "John",
        last_name: "Great",
        id: 25,
        username: "jdoe25",
        image_url: MOCK_DATA_GET_AVATARS[2].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
    {
      score: 20,
      user: {
        name: "John",
        last_name: "Good",
        id: 40,
        username: "jdoe40",
        image_url: MOCK_DATA_GET_AVATARS[1].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
    {
      score: 15,
      user: {
        name: "John",
        last_name: "Mediocre",
        id: 35,
        username: "jdoe35",
        image_url: MOCK_DATA_GET_AVATARS[3].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
    {
      score: 10,
      user: {
        name: "John",
        last_name: "Okay",
        id: 30,
        username: "jdoe30",
        image_url: MOCK_DATA_GET_AVATARS[9].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
    {
      score: 5,
      user: {
        name: "John",
        last_name: "Bad",
        id: 45,
        username: "jdoe45",
        image_url: MOCK_DATA_GET_AVATARS[5].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
    {
      score: 2,
      user: {
        name: "John",
        last_name: "Last",
        id: 50,
        username: "jdoe50",
        image_url: MOCK_DATA_GET_AVATARS[7].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
    {
      score: 1,
      user: {
        name: MOCK_DATA_GET_ME.name,
        last_name: MOCK_DATA_GET_ME.last_name,
        id: MOCK_DATA_GET_ME.id,
        username: "me",
        image_url: MOCK_DATA_GET_ME.image_url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: true,
        is_friend: false,
        relationship_state: "self",
      },
    },
  ],
};

export const mockLeaderboardMiddling: TriviaLeaderboard = {
  start_date: format(new Date(), "yyyy-MM-dd"),
  end_date: format(new Date(), "yyyy-MM-dd"),
  has_friends: true,
  scores: [
    {
      score: 25,
      user: {
        name: "John",
        last_name: "Great",
        id: 25,
        username: "jdoe25",
        image_url: MOCK_DATA_GET_AVATARS[2].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
    {
      score: 20,
      user: {
        name: "John",
        last_name: "Good",
        id: 40,
        username: "jdoe40",
        image_url: MOCK_DATA_GET_AVATARS[1].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
    {
      score: 15,
      user: {
        name: "John",
        last_name: "Mediocre",
        id: 35,
        username: "jdoe35",
        image_url: MOCK_DATA_GET_AVATARS[3].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
    {
      score: 10,
      user: {
        name: "John",
        last_name: "Okay",
        id: 30,
        username: "jdoe30",
        image_url: MOCK_DATA_GET_AVATARS[9].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
    {
      score: 7,
      user: {
        name: MOCK_DATA_GET_ME.name,
        last_name: MOCK_DATA_GET_ME.last_name,
        id: MOCK_DATA_GET_ME.id,
        username: "me",
        image_url: MOCK_DATA_GET_ME.image_url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: true,
        is_friend: false,
        relationship_state: "self",
      },
    },
    {
      score: 5,
      user: {
        name: "John",
        last_name: "Bad",
        id: 45,
        username: "jdoe45",
        image_url: MOCK_DATA_GET_AVATARS[5].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
    {
      score: 1,
      user: {
        name: "John",
        last_name: "Last",
        id: 50,
        username: "jdoe50",
        image_url: MOCK_DATA_GET_AVATARS[7].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
  ],
};

export const mockLeaderboardSame: TriviaLeaderboard = {
  start_date: format(new Date(), "yyyy-MM-dd"),
  end_date: format(new Date(), "yyyy-MM-dd"),
  has_friends: true,
  scores: [
    {
      score: 25,
      user: {
        name: "John",
        last_name: "Great",
        id: 25,
        username: "jdoe25",
        image_url: MOCK_DATA_GET_AVATARS[2].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
    {
      score: 20,
      user: {
        name: "John",
        last_name: "Good",
        id: 40,
        username: "jdoe40",
        image_url: MOCK_DATA_GET_AVATARS[1].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
    {
      score: 15,
      user: {
        name: "John",
        last_name: "Mediocre",
        id: 35,
        username: "jdoe35",
        image_url: MOCK_DATA_GET_AVATARS[3].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
    {
      score: 15,
      user: {
        name: "John",
        last_name: "Okay",
        id: 30,
        username: "jdoe30",
        image_url: MOCK_DATA_GET_AVATARS[9].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
    {
      score: 15,
      user: {
        name: MOCK_DATA_GET_ME.name,
        last_name: MOCK_DATA_GET_ME.last_name,
        id: MOCK_DATA_GET_ME.id,
        username: "me",
        image_url: MOCK_DATA_GET_ME.image_url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: true,
        is_friend: false,
        relationship_state: "self",
      },
    },
    {
      score: 15,
      user: {
        name: "John",
        last_name: "Bad",
        id: 45,
        username: "jdoe45",
        image_url: MOCK_DATA_GET_AVATARS[5].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
    {
      score: 1,
      user: {
        name: "John",
        last_name: "Last",
        id: 50,
        username: "jdoe50",
        image_url: MOCK_DATA_GET_AVATARS[7].url,
        is_admin: false,
        bio: "",
        relation_description: "",
        is_self: false,
        is_friend: true,
        relationship_state: "friends",
      },
    },
  ],
};
